<template>
    <div>
        <!-- Content Header (Page header) -->
        <div class="content-header">
            <div class="container-fluid">
                <div class="row mb-2">
                    <div class="col-sm-6">
                        <h1 class="m-0 text-dark"><i class="nav-icon fas fa-users"></i> App Users <small> App User Form</small></h1>
                    </div>
                    <!-- /.col -->
                    <div class="col-sm-6">
                        <ol class="breadcrumb float-sm-right">
                            <li class="breadcrumb-item">
                                <router-link to="/dashboard">
                                    <i class="nav-icon fas fa-home"></i> Home
                                </router-link>
                            </li>
                            <li class="breadcrumb-item active"><i class="nav-icon fas fa-users"></i> App Users</li>
                        </ol>
                    </div>
                    <!-- /.col -->
                </div>
                <!-- /.row -->
            </div>
            <!-- /.container-fluid -->
        </div>
        <!-- /.content-header -->
        <!-- Main content -->
        <section class="content">
            <div class="container-fluid">
                <div class="card card-primary card-outline">
                    <form id="form1" class="form-horizontal">
                        <div class="card-body">
                            <div class="col-xs-12 col-sm-12 col-lg-6">
                                <h4> App User Form</h4>
                                <div class="form-group row">
                                    <label for="name" class="col-sm-2 col-form-label">Name</label>
                                    <div class="col-sm-10">
                                        <input type="text" class="form-control validate[required]" id="name" name="name" v-model="entity.name" size="50" maxlength="150" placeholder="Name" />
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="email" class="col-sm-2 col-form-label">E-mail</label>
                                    <div class="col-sm-9">
                                        <input type="text" class="form-control validate[required]" id="email" name="email" v-model="entity.email" size="50" maxlength="150" placeholder="E-mail" />
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="password" class="col-sm-2 col-form-label">Password</label>
                                    <div class="col-sm-4">
                                        <input type="text" class="form-control validate[required]" id="password" name="password" v-model="entity.password" size="25" maxlength="250" placeholder="Password" />
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="birth_date" class="col-sm-2 col-form-label">Birth Date</label>
                                    <div class="col-sm-3">
                                        <date-editor v-model="entity.birth_date" />
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="phone_number" class="col-sm-2 col-form-label">Phone Number</label>
                                    <div class="col-sm-4">
                                        <input type="text" class="form-control" id="phone_number" name="phone_number" v-model="entity.phone_number" size="20" maxlength="20" placeholder="Phone Number" />
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="photo" class="col-sm-2 col-form-label">Photo</label>
                                    <div class="col-xs-6 col-sm-6 col-lg-4">
                                        <image-editor v-model="entity.photo" />
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="street" class="col-sm-2 col-form-label">Street</label>
                                    <div class="col-sm-10">
                                        <input type="text" class="form-control" id="street" name="street" v-model="entity.street" size="50" maxlength="150" placeholder="Street" />
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="street_number" class="col-sm-2 col-form-label">Street Number</label>
                                    <div class="col-sm-4">
                                        <input type="text" class="form-control" id="street_number" name="street_number" v-model="entity.street_number" size="20" maxlength="20" placeholder="Street Number" />
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="complement" class="col-sm-2 col-form-label">Complement</label>
                                    <div class="col-sm-6">
                                        <input type="text" class="form-control" id="complement" name="complement" v-model="entity.complement" size="50" maxlength="100" placeholder="Complement" />
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="neighborhood" class="col-sm-2 col-form-label">Neighborhood</label>
                                    <div class="col-sm-8">
                                        <input type="text" class="form-control" id="neighborhood" name="neighborhood" v-model="entity.neighborhood" size="50" maxlength="100" placeholder="Neighborhood" />
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="city" class="col-sm-2 col-form-label">City</label>
                                    <div class="col-sm-8">
                                        <input type="text" class="form-control" id="city" name="city" v-model="entity.city" size="50" maxlength="100" placeholder="City" />
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="state" class="col-sm-2 col-form-label">State</label>
                                    <div class="col-sm-6">
                                        <input type="text" class="form-control" id="state" name="state" v-model="entity.state" size="50" maxlength="100" placeholder="State" />
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="postal_code" class="col-sm-2 col-form-label">Postal Code</label>
                                    <div class="col-sm-4">
                                        <input type="text" class="form-control" id="postal_code" name="postal_code" v-model="entity.postal_code" size="20" maxlength="20" placeholder="Postal Code" />
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="country" class="col-sm-2 col-form-label">Country</label>
                                    <div class="col-sm-5">
                                        <input type="text" class="form-control" id="country" name="country" v-model="entity.country" size="50" maxlength="100" placeholder="Country" />
                                    </div>
                                </div>

                                <h4>Status</h4>
                                <div class="form-group row">
                                    <label class="col-sm-2 col-form-label"></label>
                                    <div class="col-sm-10">
                                        <div class="radio">
                                            <label class="form-radio form-icon">
                                                <input type="radio" name="status_app_user" data-icheck="green" v-model="entity.status_app_user" v-bind:value="true" />
                                                Active
                                            </label>
                                            <label class="form-radio form-icon">
                                                <input type="radio" name="status_app_user" data-icheck="red" v-model="entity.status_app_user" v-bind:value="false" />
                                                Inactive
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                    <div class="card-footer">
                        <div class="offset-sm-1 col-sm-11">
                            <button type="button" v-if="this.$route.params.id == 0" v-on:click="insertEntity" class="btn btn-success btn-social"> <i class="fas fa-check"></i> Insert</button>
                            <button type="button" v-if="this.$route.params.id != 0" v-on:click="updateEntity" class="btn btn-info btn-social"> <i class="fas fa-pencil-alt"></i> Update</button>
                            <button type="button" v-if="this.$route.params.id != 0" v-on:click="deleteEntity" class="btn btn-danger btn-social"> <i class="fas fa-times"></i> Delete</button>
                            <button type="button" v-on:click="back" class="btn btn-default btn-social"><i class="fas fa-history"></i> Voltar</button>
                        </div>
                    </div>
                </div>
            </div>
            <!-- /.container-fluid -->
        </section>
        <!-- /.content -->
    </div>
</template>

<script>
    import AppUserController from "@/controllers/app_user.controller";

    export default {
        data: function () {
            return {
                entity: {}
            };
        },
        mounted() {
            this.$validator.validate("#form1");
            const id = parseInt(this.$route.params.id, 10);
            this.loadEntity(id);
            $(":input").inputmask();
        },
        methods: {
            loadEntity: function (id) {

                if (id === 0)
                    return;

                AppUserController.getById(id)
                    .then(response => {
                        this.entity = response.data.result;
                    });
            },
            insertEntity: function (event) {
                if (!this.$validator.isValid("#form1"))
                return;

                event.target.disabled = true;

                let vm = this;

                AppUserController.insert(vm.entity)
                    .then(response => {
                        if (!response.data.success) {
                            vm.$toastr.error(response.data.error, 'Error!', {
                                timeOut: 8000,
                                onHidden: function () {
                                    event.target.disabled = false;
                                }
                            });
                            return;
                        }

                        vm.$toastr.success("Saved successfully.", "Notice",
                            {
                                onHidden: function () {
                                    event.target.disabled = false;
                                    vm.back();
                                }
                            }
                        );
                    })
                    .catch(e => {
                        event.target.disabled = false;
                        vm.$toastr.error(e, 'Error!', { timeOut: 8000 });
                    });
            },
            updateEntity: function (event) {
                if (!this.$validator.isValid("#form1"))
                return;

                event.target.disabled = true;

                let vm = this;

                AppUserController.update(vm.entity)
                    .then(response => {
                        if (!response.data.success) {
                            vm.$toastr.error(response.data.error, 'Error!', {
                                timeOut: 8000,
                                onHidden: function () {
                                    event.target.disabled = false;
                                }
                            });
                            return;
                        }

                        vm.$toastr.success("Saved successfully.", "Notice",
                            {
                                onHidden: function () {
                                    event.target.disabled = false;
                                    vm.back();
                                }
                            });
                    })
                    .catch(e => {
                        event.target.disabled = false;
                        vm.$toastr.error(e, 'Error!', { timeOut: 8000 });
                    });
            },
            deleteEntity: function (event) {
                event.target.disabled = true;

                let vm = this;

                vm.$dialogs.confirm({
                    title: 'Confirm Deletion!',
                    content: 'Are you sure you want to delete this?',
                    icon: 'fa fa-exclamation-triangle ',
                    type: 'red',
                    buttons: {
                        confirm: {
                            text: 'Confirm',
                            btnClass: 'btn-red',
                            action: function () {
                                event.target.disabled = true;

                                AppUserController.delete(vm.entity)
                                    .then(response => {

                                        if (!response.data.success) {
                                            vm.$toastr.error(response.data.error, 'Error!', {
                                                timeOut: 8000,
                                                onHidden: function () {
                                                    event.target.disabled = false;
                                                }
                                            });
                                            return;
                                        }

                                        vm.$toastr.success("Deleted successfully.", "Notice",
                                            {
                                                onHidden: function () {
                                                    vm.back();
                                                }
                                            }
                                        );
                                    })
                                    .catch(e => {
                                        vm.$toastr.error(e, 'Error!', { timeOut: 8000 });
                                        event.target.disabled = false;
                                    });
                            }
                        },
                        close: {
                            text: 'Cancel'
                        }
                    }
                });
                event.target.disabled = false;
            },
            back: function () {
                this.$router.push({ name: "list-app_user" });
            }
        }
    };
</script>

<style scoped>
</style>